import { AppModule } from './../../app.module';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(
    public app : AppModule
  ) { }

  ngOnInit(): void {
  }

  switchLang(lang: string){
    this.app.swicthLang(lang)
    var someElement:any = document.getElementById("headerDropdown");
        someElement.classList.remove("show");
  }


  dropdownMenu(){
    var someElement:any = document.getElementById("headerDropdown");
        someElement.className += " show";    
  }
}
